import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap"

import FullCalendar from "@fullcalendar/react" // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid" // a plugin!

import { post } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"

import BootstrapTable from "react-bootstrap-table-next"
import filterFactory, { textFilter } from "react-bootstrap-table2-filter"
import paginationFactory from "react-bootstrap-table2-paginator"

import Task from "../Common/Task"
import UnplannedTask from "../Common/UnplannedTask"
import moment from "moment"
import { connect } from "react-redux"

const monthNames = [
  "",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

const Dashboard = props => {
  const [isOpen, setIsOpen] = useState(false)

  const [initializing, setInitializing] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [data, setData] = React.useState([])

  const [query, setQuery] = React.useState("scheduled")

  const [taskId, setTaskId] = React.useState(null)
  const [unplannedTaskId, setUnplannedTaskId] = React.useState(null)

  const [events, setEvents] = React.useState([])
  const [serviceTypes, setServiceTypes] = React.useState([])
  const [groups, setGroups] = React.useState([])
  const [serviceType, setServiceType] = React.useState(null) // For hover dropdown
  const [serviceTypeId, setServiceTypeId] = React.useState(null) // For click & fetch data
  const [groupId, setGroupId] = React.useState(null) // For click & fetch data

  const [currMonth, setCurrMonth] = React.useState(moment().format("MM"))
  const [currYear, setCurrYear] = React.useState(moment().format("YYYY"))
  const calRef = React.useRef()

  const [selectedDate, setSelectedDate] = useState(null)
  const [selectedType, setSelectedType] = useState(null)

  // Stat Tiles
  const [totalTasks, setTotalTasks] = React.useState(0)
  const [completedTasks, setCompletedTasks] = React.useState(0)
  const [activeMobileUsers, setActiveMobileUsers] = React.useState("-")
  const [contract, setContract] = React.useState("-")

  const taskTypes = {
    completed: "Completed",
    delayed: "Delayed",
    cancelled: "Cancelled",
    missed: "Missed",
    unsync: "Unsync",
    pending: "Pending",
    bounced: "Bounced",
    unplanned: "Unplanned",
    total: "All",
  }

  const columns = [
    {
      dataField: "slno",
      text: "#",
    },
    {
      dataField: "activity.name",
      text: "Activity name",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "asset.name",
      text: "Asset",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "task_date",
      text: "Scheduled Date",
      sort: true,
      filter: textFilter(),
      formatter: (cell, row, rowIndex) => (
        <div>
          <div>{moment(cell).format("DD MMM YYYY")}</div>
          <div>
            {row.start_time?.substring(0, 5) +
              " - " +
              row.end_time?.substring(0, 5)}
          </div>
        </div>
      ),
      filterValue: (cell, row, rowIndex) => (
        <div>
          <div>{moment(cell).format("DD MMM YYYY")}</div>
          <div>
            {row.start_time?.substring(0, 5) +
              " - " +
              row.end_time?.substring(0, 5)}
          </div>
        </div>
      ),
      csvFormatter: (cell, row, rowIndex) => (
        <div>
          <div>{moment(cell).format("DD MMM YYYY")}</div>
          <div>
            {row.start_time?.substring(0, 5) +
              " - " +
              row.end_time?.substring(0, 5)}
          </div>
        </div>
      ),
    },
    // {
    //   dataField: "ended_at",
    //   text: "Done at",
    //   sort: true,
    //   filter: textFilter(),
    //   formatter: (cell, row, rowIndex) =>
    //     row.task_status == "completed" ? (
    //       <div>
    //         <div>{moment(row).format("DD MMM YYYY")}</div>
    //         <div>{moment(row).format("hh:mm a")}</div>
    //       </div>
    //     ) : (
    //       "-"
    //     ),
    //   filterValue: (cell, row, rowIndex) =>
    //     row.task_status == "completed" ? (
    //       <div>
    //         <div>{moment(row).format("DD MMM YYYY")}</div>
    //         <div>{moment(row).format("hh:mm a")}</div>
    //       </div>
    //     ) : (
    //       "-"
    //     ),
    //   csvFormatter: (cell, row, rowIndex) =>
    //     row.task_status == "completed" ? (
    //       <div>
    //         <div>{moment(row).format("DD MMM YYYY")}</div>
    //         <div>{moment(row).format("hh:mm a")}</div>
    //       </div>
    //     ) : (
    //       "-"
    //     ),
    // },
    {
      dataField: "ended_at",
      text: "Done at",
      sort: true,
      filter: textFilter(),
      formatter: (cell, row, rowIndex) =>
        row.task_status == "completed" ? (
          <div>
            <div>{moment(row.ended_at).format("DD MMM YYYY")}</div>
            <div>{moment(row.ended_at).format("hh:mm a")}</div>
          </div>
        ) : (
          "-"
        ),
      filterValue: (cell, row, rowIndex) =>
        row.task_status == "completed" ? (
          <div>
            <div>{moment(row).format("DD MMM YYYY")}</div>
            <div>{moment(row).format("hh:mm a")}</div>
          </div>
        ) : (
          "-"
        ),
      csvFormatter: (cell, row, rowIndex) =>
        row.task_status == "completed" ? (
          <div>
            <div>{moment(row).format("DD MMM YYYY")}</div>
            <div>{moment(row).format("hh:mm a")}</div>
          </div>
        ) : (
          "-"
        ),
    },
    {
      dataField: "user",
      text: "Done by",
      sort: true,
      filter: textFilter(),
      formatter: (cell, row, rowIndex) => (cell ? cell.name : "-"),
      filterValue: (cell, row, rowIndex) => (cell ? cell.name : "-"),
      csvFormatter: (cell, row, rowIndex) => (cell ? cell.name : "-"),
    },
    {
      dataField: "task_status",
      text: "Status",
      sort: true,
      filter: textFilter(),
      formatter: row => {
        return (
          <span
            style={{
              color:
                row == "completed"
                  ? "rgb(77, 163, 77)"
                  : row == "pending"
                  ? "rgb(217, 171, 88)"
                  : row == "missed"
                  ? "red"
                  : "#222",
            }}
          >
            {row}
          </span>
        )
      },
    },
  ]

  const columnsUnplanned = [
    {
      dataField: "slno",
      text: "#",
    },
    {
      dataField: "asset.name",
      text: "Asset",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "form.name",
      text: "Form",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "ended_at",
      text: "Done at",
      sort: true,
      filter: textFilter(),
      formatter: (cell, row, rowIndex) => (
        <div>
          <div>{moment(row).format("DD MMM YYYY")}</div>
          <div>{moment(row).format("hh:mm a")}</div>
        </div>
      ),
      filterValue: (cell, row, rowIndex) => (
        <div>
          <div>{moment(row).format("DD MMM YYYY")}</div>
          <div>{moment(row).format("hh:mm a")}</div>
        </div>
      ),
      csvFormatter: (cell, row, rowIndex) => (
        <div>
          <div>{moment(row).format("DD MMM YYYY")}</div>
          <div>{moment(row).format("hh:mm a")}</div>
        </div>
      ),
    },
    {
      dataField: "user",
      text: "Done by",
      sort: true,
      filter: textFilter(),
      formatter: (cell, row, rowIndex) => (cell ? cell.name : "-"),
      filterValue: (cell, row, rowIndex) => (cell ? cell.name : "-"),
      csvFormatter: (cell, row, rowIndex) => (cell ? cell.name : "-"),
    },
  ]

  const toggle = () => setIsOpen(!isOpen)

  const fetchData = (month, year, servicetype_id, group_id) => {
    if (!props.filterBlock) {
      return
    }
    setInitializing(true)
    post(url.GET_DASHBOARD, {
      block_id: props.filterBlock.id,
      month: month.toString(),
      year: year,
      servicetype_id: servicetype_id,
      group_id: group_id,
    })
      .then(response => {
        console.log("RESP", response)
        if (response.status == 200) {
          setEvents(response.data.events)
          setServiceTypes(response.data.servicetypes)
          setGroups(response.data.groups)
          setInitializing(false)
          setCurrMonth(month)
          setCurrYear(year)
        } else {
          setData(null)
          setInitializing(false)
        }
      })
      .catch(error => {
        console.log("err:", error)
        setInitializing(false)
      })
  }

  const fetchList = (lDate, type, servicetype_id, group_id) => {
    if (!props.filterBlock) {
      return
    }
    setLoading(true)
    // console.log(lDate, type);
    post(url.GET_TASK_LIST, {
      date: lDate,
      type: type,
      block_id: props.filterBlock.id,
      servicetype_id: servicetype_id,
      group_id: group_id,
    })
      .then(response => {
        console.log("RESP", response.data)
        if (response.status == 200) {
          setData(response.data.tasks)
          setSelectedDate(response.data.date)
          setSelectedType(response.data.type)
          setTotalTasks(response.data.total)
          setCompletedTasks(response.data.completed)
          setLoading(false)
        } else {
          setData(null)
          setLoading(false)
        }
      })
      .catch(error => {
        console.log("err:", error)
        setLoading(false)
      })
  }

  const init = async () => {
    // await generate();
    await fetchData(
      moment().format("MM"),
      moment().format("YYYY"),
      serviceTypeId,
      groupId ? groupId.value : null
    )
  }

  React.useEffect(() => {
    if (props.filterBlock) {
      setData([])
      setSelectedDate(null)
      setSelectedType(null)
      init()
    }
  }, [props.filterBlock])

  const displayed =
    query == "" ? data : data.filter(a => a.task_status == query)
  const completed = data.filter(a => a.task_status == "completed")
  const dispGroups = serviceType
    ? groups.filter(g => g.servicetype_id == serviceType.value)
    : groupId
    ? groups.filter(g => g.servicetype_id == groupId.servicetype_id)
    : []

  const noData = (
    <div className="text-muted py-5 text-center">
      {props.filterBlock
        ? selectedDate
          ? "No tasks to display"
          : "Please select a date"
        : "Please select Property and Block"}
    </div>
  )

  // console.log('dispGroups', dispGroups, serviceType)

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Dashboard | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <h3 className="mb-4">Dashboard</h3>

          <div className="row mt-4">
            <div className="col-md-3">
              <div className="mini-stats-wid card">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Daily Tasks</p>
                      <h4 className="mb-0">
                        {loading || initializing || !selectedDate
                          ? "-"
                          : totalTasks}
                      </h4>
                    </div>
                    <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                      <span className="avatar-title">
                        <i className="bx bx-calendar font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="mini-stats-wid card">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Completed Tasks</p>
                      <h4 className="mb-0">
                        {loading ||
                        initializing ||
                        !selectedDate ||
                        totalTasks == 0 ||
                        totalTasks == "0"
                          ? "-"
                          : completedTasks +
                            "/" +
                            (totalTasks < 1
                              ? "0%"
                              : ((completedTasks / totalTasks) * 100).toFixed(
                                  0
                                ) + "%")}
                      </h4>
                    </div>
                    <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                      <span className="avatar-title">
                        <i className="bx bx-calendar-check font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="mini-stats-wid card">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">
                        Active Mobile Users
                      </p>
                      <h4 className="mb-0">{activeMobileUsers}</h4>
                    </div>
                    <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                      <span className="avatar-title">
                        <i className="bx bx-mobile-alt font-size-24"></i>
                      </span>
                      Dashboard
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="mini-stats-wid card">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Contracts</p>
                      <h4 className="mb-0">{contract}</h4>
                    </div>
                    <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                      <span className="avatar-title">
                        <i className="bx bx-file font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* { serviceTypes.length > 0 && */}
          <div
            className="my-2"
            onMouseLeave={() => {
              setServiceType(null)
            }}
          >
            <div className="dash-servicetypes">
              <button
                className={
                  serviceTypeId == null
                    ? "btn btn-primary me-2 dash-servicetype"
                    : "btn btn-outline-primary me-2 dash-servicetype"
                }
                onMouseEnter={() => {
                  setServiceType(null)
                }}
                onClick={() => {
                  setServiceTypeId(null)
                  setGroupId(null)
                  if (selectedDate) {
                    fetchList(selectedDate, selectedType, null)
                  }
                  let calMom = moment(
                    calRef.current.getApi().getCurrentData().currentDate
                  )
                  fetchData(
                    calMom.format("MM"),
                    calMom.format("YYYY"),
                    null,
                    null
                  )
                }}
              >
                All
              </button>
              {serviceTypes.map((sType, sTypeIdx) => (
                <button
                  className={
                    serviceTypeId == sType.value
                      ? "btn btn-primary me-2 dash-servicetype"
                      : "btn btn-outline-primary me-2 dash-servicetype"
                  }
                  key={sTypeIdx}
                  onMouseEnter={() => {
                    setServiceType(sType)
                  }}
                  onClick={async () => {
                    setServiceTypeId(sType.value)
                    setGroupId(null)
                    if (selectedDate) {
                      fetchList(selectedDate, selectedType, sType.value, null)
                    }
                    let calMom = moment(
                      calRef.current.getApi().getCurrentData().currentDate
                    )
                    fetchData(
                      calMom.format("MM"),
                      calMom.format("YYYY"),
                      sType.value,
                      null
                    )
                  }}
                >
                  {sType.label}
                </button>
              ))}
            </div>

            <div className="mt-2 mb-2 dash-servicetypes">
              {dispGroups.map((group, groupIdx) => (
                <button
                  className={
                    groupId
                      ? groupId.value == group.value
                        ? "btn btn-secondary me-2 dash-servicetype"
                        : "btn btn-outline-secondary me-2 dash-servicetype"
                      : "btn btn-outline-secondary me-2 dash-servicetype"
                  }
                  key={groupIdx}
                  onClick={() => {
                    // console.log('group', group);
                    setServiceTypeId(group.servicetype_id)
                    setGroupId(group)
                    if (selectedDate) {
                      fetchList(
                        selectedDate,
                        selectedType,
                        group.servicetype_id,
                        group.value
                      )
                    }
                    let calMom = moment(
                      calRef.current.getApi().getCurrentData().currentDate
                    )
                    fetchData(
                      calMom.format("MM"),
                      calMom.format("YYYY"),
                      group.servicetype_id,
                      group.value
                    )
                  }}
                >
                  {group.label}
                </button>
              ))}
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-4">
              <Card>
                <CardBody>
                  <div className="position-relative ">
                    {loading && (
                      <div
                        className="position-absolute top-0 bottom-0 end-0 start-0 d-flex justify-content-center align-items-start text-muted"
                        style={{
                          backgroundColor: "rgba(255,255,255,0.4)",
                          zIndex: 99,
                          paddingTop: 150,
                        }}
                      >
                        Loading..
                      </div>
                    )}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="cal-title">
                        {monthNames[parseInt(currMonth)]} {currYear}
                      </h4>
                      <div className="cal-toolbar">
                        <button
                          className="btn me-3"
                          onClick={() => {
                            setSelectedDate(null)
                            calRef.current.getApi().today()
                            fetchData(
                              moment().format("MM"),
                              moment().format("YYYY"),
                              serviceTypeId,
                              groupId ? groupId.value : null
                            )
                            fetchList(
                              moment().format("YYYY-MM-DD"),
                              "total",
                              serviceTypeId,
                              groupId ? groupId.value : null
                            )
                          }}
                        >
                          today
                        </button>
                        <button
                          className="btn"
                          onClick={async () => {
                            await setSelectedDate(null)
                            await calRef.current.getApi().prev()
                            let calMom = moment(
                              calRef.current.getApi().getCurrentData()
                                .currentDate
                            )
                            fetchData(
                              calMom.format("MM"),
                              calMom.format("YYYY"),
                              serviceTypeId,
                              groupId ? groupId.value : null
                            )
                          }}
                        >
                          <i className="bx bx-chevron-left font-size-24"></i>
                        </button>
                        <button
                          className="btn"
                          onClick={async () => {
                            await setSelectedDate(null)
                            await calRef.current.getApi().next()
                            let calMom = moment(
                              calRef.current.getApi().getCurrentData()
                                .currentDate
                            )
                            fetchData(
                              calMom.format("MM"),
                              calMom.format("YYYY"),
                              serviceTypeId,
                              groupId ? groupId.value : null
                            )
                          }}
                        >
                          <i className="bx bx-chevron-right font-size-24"></i>
                        </button>
                      </div>
                    </div>
                    <FullCalendar
                      plugins={[dayGridPlugin]}
                      initialView="dayGridMonth"
                      ref={calRef}
                      // eventContent={renderEventContent}
                      events={events}
                      eventOrder="order"
                      // eventRender: function(event, element) {
                      //     element.attr('title', event.tooltip);
                      // }
                      selectable
                      height="auto"
                      eventClick={e => {
                        fetchList(
                          moment(e.event.start).format("YYYY-MM-DD"),
                          e.event.extendedProps.type,
                          serviceTypeId,
                          groupId ? groupId.value : null
                        )
                      }}
                      headerToolbar={false}
                    />
                    {/* <div className="pt-5 d-flex flex-row flex-wrap justify-content-center align-items-center">
                      <div className="fs-5">Legend</div>
                    </div> */}
                    <div className="pt-4 pb-2 d-flex flex-row flex-wrap justify-content-center align-items-center">
                      <div className="px-3 py-2 flex-1 d-flex flex-row justify-content-center align-items-center">
                        <div className="indicator me-2 task-total" />
                        <div className="" style={{ color: "#9F9FA7" }}>
                          Total
                        </div>
                      </div>
                      <div className="px-3 py-2 flex-1 d-flex flex-row justify-content-center align-items-center">
                        <div className="indicator me-2 task-completed" />
                        <div className="" style={{ color: "#9F9FA7" }}>
                          Completed
                        </div>
                      </div>
                      <div className="px-3 py-2 flex-1 d-flex flex-row justify-content-center align-items-center">
                        <div className="indicator me-2 task-delayed" />
                        <div className="" style={{ color: "#9F9FA7" }}>
                          Delayed
                        </div>
                      </div>
                      <div className="px-3 py-2 flex-1 d-flex flex-row justify-content-center align-items-center">
                        <div className="indicator me-2 task-cancelled" />
                        <div className="" style={{ color: "#9F9FA7" }}>
                          Cancelled
                        </div>
                      </div>
                      <div className="px-3 py-2 flex-1 d-flex flex-row justify-content-center align-items-center">
                        <div className="indicator me-2 task-missed" />
                        <div className="" style={{ color: "#9F9FA7" }}>
                          Missed
                        </div>
                      </div>
                      <div className="px-3 py-2 flex-1 d-flex flex-row justify-content-center align-items-center">
                        <div className="indicator me-2 task-pending" />
                        <div className="" style={{ color: "#9F9FA7" }}>
                          Pending
                        </div>
                      </div>
                      <div className="px-3 py-2 flex-1 d-flex flex-row justify-content-center align-items-center">
                        <div className="indicator me-2 task-unplanned" />
                        <div className="" style={{ color: "#9F9FA7" }}>
                          Unplanned
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="col-md-8 ">
              <Card>
                <CardBody className="dashboard-tasks-pane">
                  <CardTitle tag="h3" className="mb-2">
                    {props.filterProperty && props.filterBlock
                      ? props.filterProperty.name +
                        " / " +
                        props.filterBlock.name
                      : "-"}
                  </CardTitle>
                  <CardSubtitle tag="h5" className="mb-4 text-muted">
                    {selectedDate
                      ? moment(selectedDate).format("DD MMM YYYY") +
                        (selectedType &&
                          "- " + taskTypes[selectedType] + " tasks")
                      : "No date selected"}
                  </CardSubtitle>
                  <BootstrapTable
                    hover
                    className="table-tasks-dashboard"
                    keyField="id"
                    data={data}
                    columns={
                      selectedType == "unplanned" ? columnsUnplanned : columns
                    }
                    filter={filterFactory()}
                    pagination={paginationFactory()}
                    rowEvents={{
                      onClick: (e, row, rowIndex) => {
                        if (selectedType == "unplanned") {
                          setUnplannedTaskId(row.id)
                        } else {
                          setTaskId(row.id)
                        }
                      },
                    }}
                    noDataIndication={noData}
                    loading={loading}
                  />
                </CardBody>
              </Card>
            </div>
          </div>
        </Container>

        {taskId !== null && (
          <Task mode="daily" id={taskId} setTaskId={setTaskId} />
        )}

        {unplannedTaskId !== null && (
          <UnplannedTask
            mode="daily"
            id={unplannedTaskId}
            setUnplannedTaskId={setUnplannedTaskId}
          />
        )}
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = state => {
  const { filterBlock, filterProperty } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(Dashboard)
